import { StepSeparator } from "@images/svgIcons/navigation/stepSeparator"
import { FiveIcon } from "@images/svgIcons/numbers/fiveIcon"
import { FourIcon } from "@images/svgIcons/numbers/fourIcon"
import { OneIcon } from "@images/svgIcons/numbers/oneIcon"
import { ThreeIcon } from "@images/svgIcons/numbers/threeIcon"
import { TwoIcon } from "@images/svgIcons/numbers/twoIcon"

type BoxFormPageNumberProps = {
  disabled: boolean
  pageNumber: number
}
export function BoxFormPageNumber({ disabled, pageNumber }: BoxFormPageNumberProps) {
  const NumberIcon = () => {
    const props = {
      color: "var(--color-white)",
      className: "absolute",
      width: 27,
      height: 35,
      style: { zIndex: 1, marginTop: "6px", marginLeft: "10px" },
    }
    switch (pageNumber) {
      case 1:
        return <OneIcon {...props} />
      case 2:
        return <TwoIcon {...props} />
      case 3:
        return <ThreeIcon {...props} />
      case 4:
        return <FourIcon {...props} />
      case 5:
        return <FiveIcon {...props} />
    }
  }

  return (
    <div style={{ width: "70px", height: "70px" }}>
      <NumberIcon />

      <StepSeparator color={disabled ? "var(--neutral-400)" : "var(--primary-400)"} className="absolute" />

      <StepSeparator
        color={disabled ? "var(--neutral-400)" : "var(--primary-400)"}
        className="absolute"
        style={{ marginTop: "10px" }}
      />

      <FiveIcon
        color={disabled ? "var(--neutral-400)" : "var(--primary-400)"}
        className="absolute"
        width={27}
        height={35}
        style={{ marginLeft: "40px", marginTop: "40px" }}
      />
    </div>
  )
}
